/** @file Two-tab login UI: username+password or email OTP. */
import p from 'vue-strict-prop';
import * as tsx from 'vue-tsx-support';
import * as tabs from '@/components/Tabs';
import * as utils from '@/utils';
import { EmailForm } from './EmailForm';
import { UsernameAndPasswordForm } from './UsernameAndPasswordForm';
const TAB_USERNAME = 'username';
const TAB_EMAIL = 'email';
/** Two-tab login component offering username/password or email OTP login. */
export const LoginMethods = tsx.component({
    name: 'login-methods',
    props: {
        tenant: p.ofType().required,
        submit: p.ofType().required,
    },
    computed: {
        /** @returns The active tab, read from the `login_method` query param, falling back to `TAB_USERNAME`. */
        currentTab() {
            const tab = this.$route.query.login_method;
            return tab === TAB_USERNAME || tab === TAB_EMAIL ? tab : TAB_USERNAME;
        },
    },
    methods: {
        /**
         * Persists the selected tab to the URL as `login_method`, preserving all other query params.
         *
         * @param tab The tab name to save.
         */
        setTab(tab) {
            this.$router.replace({
                ...this.$route,
                query: { ...this.$route.query, login_method: tab },
            });
        },
    },
    /** @returns The rendered login methods JSX. */
    render() {
        return (<tabs.TabGroup defaultTab={TAB_USERNAME} selectedTab={this.currentTab} onChange={this.setTab} class="min-h-80">
                <tabs.TabList variant="button-group" class="mb-3">
                    <tabs.TabButton tabName={TAB_USERNAME} label="Login with username" variant="button-group"/>
                    <tabs.TabButton tabName={TAB_EMAIL} label="Login with email" variant="button-group"/>
                </tabs.TabList>
                <tabs.TabPanel tabName={TAB_USERNAME} class="contents">
                    {utils.ifOrEmpty(this.currentTab === TAB_USERNAME, () => (<UsernameAndPasswordForm tenant={this.tenant} submit={payload => this.submit({ tag: 'username', ...payload })}/>))}
                </tabs.TabPanel>
                <tabs.TabPanel tabName={TAB_EMAIL} class="contents">
                    {utils.ifOrEmpty(this.currentTab === TAB_EMAIL, () => (<EmailForm submit={email => this.submit({ tag: 'email', email })}/>))}
                </tabs.TabPanel>
            </tabs.TabGroup>);
    },
});
